import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import TimelineItem from "./TimelineItem"; // Import the TimelineItem component
import NavbarWithPushContent from "./NavbarWithPushContent";
import useHistory from "../Hooks/useHistory";
import LoadingSpinner from "../Assets/LoadingSpinner";
import ErrorComponent from "../Assets/ErrorComponent";
import { Product } from "../Types/Types";
import { useTranslation } from "react-i18next";
import Reveal from "../Assets/Reveal";

type ProductCategory = {
  _id: string;
  name: string;
  subcategories: { name: string; products: any[] }[];
  products: Product[];
};

interface HistoryProps {
  products: ProductCategory[];
  lang: string;
}


const History: React.FC<HistoryProps> = ({ products, lang }) => {
  const { t } = useTranslation();
  const { history, loading, error } = useHistory();


  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorComponent message={error} />

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="hidden md:block">
        <NavbarWithPushContent products={products} lang={lang} />
      </div>
      <div className="block md:hidden">
        <Navbar products={products} lang={lang} />
      </div>

      {/* Page header */}
      <header className="bg-gray-100 px-4 pt-28 md:pt-36 pb-12">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-brand-gray">
            {t("navbar.history")}
          </h1>
          <span className="mx-auto mt-5 block h-1 w-20 rounded-full bg-brand-400" />
        </div>
      </header>

      {/* Timeline + image */}
      <section className="bg-gray-50 px-4 py-16">
        <div className="max-w-6xl mx-auto flex flex-col gap-12 lg:flex-row lg:gap-16">
          {/* Timeline — comes first on mobile (years before the image) */}
          <div className="w-full lg:w-3/5">
            {history.map((item, index) => (
              <Reveal key={item._id} delay={index * 80}>
                <TimelineItem
                  text={item.text}
                  lang={lang}
                  isLast={index === history.length - 1}
                />
              </Reveal>
            ))}
          </div>

          {/* Image — sticky alongside the timeline on desktop, below it on mobile */}
          <div className="w-full lg:w-2/5">
            <div className="lg:sticky lg:top-28">
              <img
                src="2/history.jpg"
                alt="History"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default History;
